import { render, staticRenderFns } from "./S_DetailsNei.vue?vue&type=template&id=853cc024&scoped=true"
import script from "./S_DetailsNei.vue?vue&type=script&lang=js"
export * from "./S_DetailsNei.vue?vue&type=script&lang=js"
import style0 from "./S_DetailsNei.vue?vue&type=style&index=0&id=853cc024&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853cc024",
  null
  
)

export default component.exports